
const TextSize = {
    size10: '10px',
    size12: '12px',
    size14: '14px',
    size16: '16px',
    size18: '18px',
    size20: '20px',
    size22: '22px',
    size24: '24px',
    size26: '26px',
    size28: '28px',
    size30: '30px',
    size32: '32px',
    size34: '34px',
    size36: '36px',
    size38: '38px',
    size40: '40px',
    size42: '42px',
    size44: '44px',
    size46: '46px',
    size48: '48px',
    size50: '50px',
}

export default TextSize;